export enum DYNAMIC_PAGE {
  HOME_SLUG = 'home',
  HOME_PATH = '/',
  DEFAULT_TITLE = 'KIJK opent je ogen'
}
